import CompanyModel from '@mm/state/model/CompanyModel';
import {
  closeModal,
  openCreateCompanyModal,
} from '@mm/state/modules/modalsState/actions';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Label } from 'reactstrap';
import { compose, withHandlers } from 'recompose';
import { Dispatch } from 'redux';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import './CreateCompanyWarningModal.scss';

type PropsFromMapStateToProps = ReturnType<typeof mapStateToProps>;
type PropsFromMapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

type OuterProps = {
  companies: CompanyModel[];
};

type PropsForHandlers = PropsFromMapStateToProps &
  PropsFromMapDispatchToProps &
  OuterProps;

type OnSubmitClick = (props: PropsForHandlers) => (e: any) => void;

type PropsFromWithHandlers = {
  onSubmitClick: OnSubmitClick;
};

type InnerProps = PropsFromMapStateToProps &
  PropsFromMapDispatchToProps &
  RouteComponentProps<any> &
  PropsFromWithHandlers;

const mapStateToProps = (state: StoreState) => ({
  session: state.session.session,
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  openCreateCompanyModal: (companies: CompanyModel[]) =>
    dispatch(openCreateCompanyModal(companies)),
});

const onSubmitClick: OnSubmitClick =
  ({ openCreateCompanyModal, companies }) =>
  e => {
    closeModal();
    openCreateCompanyModal(companies);
  };

type Props = InnerProps & OuterProps;

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({ onSubmitClick }),
);

const CreateCompanyWarningModal = (props: Props) => {
  const { onSubmitClick } = props;

  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  return (
    <div className="create-company-warning-modal">
      <ModalHeader className="create-company-warning-modal__header">
        Warning
      </ModalHeader>
      <ModalBody className="create-company-warning-modal__body">
        <Label className="create-company-warning-modal__input-wrapper">
          <div className="create-company-warning-modal__input-with-error">
            <p>
              Your new company will be entirely separate from your current
              companies. No users, Facebook Pages, or Chatbots will be moved.
              Any Facebook Pages connected to your new company will be billed
              separately from your current companies if they are upgraded to
              {november2021Pricing ? ' Startup' : ' Operator'}. If you have an
              Agency Plan, it is only valid for one company.
            </p>
            <p>
              If you simply wish to restrict users&apos; access to only one
              Facebook Page or to several Facebook Pages, consider inviting them
              to your current company as an Editor instead.
            </p>
          </div>
        </Label>
      </ModalBody>
      <ModalFooter className="create-company-warning-modal__footer">
        <Button
          className="create-company-warning-modal__action"
          onClick={onSubmitClick}
        >
          Ok, I Understand
        </Button>
      </ModalFooter>
    </div>
  );
};

export default enhance(CreateCompanyWarningModal);
